module.exports = __webpack_public_path__ + "img/download-qrcode.6e58263b.png";